// extracted by mini-css-extract-plugin
export default {"ContactFormGeneric":"ContactFormGeneric_ContactFormGeneric__GRvQU","stickyBottom":"ContactFormGeneric_stickyBottom__p9lDO"};